import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=2b857e9e&scoped=true&"
import script from "./UserSelect.vue?vue&type=script&lang=js&"
export * from "./UserSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b857e9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\PhpstormProjects\\warehouse\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b857e9e')) {
      api.createRecord('2b857e9e', component.options)
    } else {
      api.reload('2b857e9e', component.options)
    }
    module.hot.accept("./UserSelect.vue?vue&type=template&id=2b857e9e&scoped=true&", function () {
      api.rerender('2b857e9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/typo3conf/ext/ig_warehouse/Resources/Public/Src/JavaScript/components/form/UserSelect.vue"
export default component.exports